const PIXEL_ID = "1160645649064267";

export function loadFbq() {
  if (typeof window === "undefined") return;
  if (window.fbq && window.__fbqLoaded) return;

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.__fbqLoaded = true;

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  window.fbq("set", "autoConfig", false, PIXEL_ID);
  window.fbq("dataProcessingOptions", ["LDU"], 0, 0);

  window.__fbqEnabled = true;
}

export function disableFbq() {
  if (typeof window === "undefined") return;

  window.__fbqEnabled = false;

  if (!window.fbq) {
    window.fbq = function noop() {};
  }
}

export function enableFbq() {
  if (typeof window === "undefined") return;
  window.__fbqEnabled = true;
}

export function track(event, params = {}) {
  if (typeof window !== "undefined" && typeof window.fbq === "function" && window.__fbqEnabled) {
    window.fbq("track", event, params);
  }
}
